export const aboutData = {
  brandName: '蘑菇视频在线观看',
  slogan: '海量高清视频，随时随地免费看',
  founded: '2018年',
  headquarters: '中国 · 北京',
  teamSize: '500+人',
  users: '超过5000万',
  videos: '超过100万部',
  
  intro: '蘑菇视频在线观看成立于2018年，是国内领先的免费高清在线视频平台。我们致力于为广大用户提供海量优质视频内容，涵盖纪录片、科技、影视、教育、美食、旅游、音乐、体育、汽车等多个领域。经过多年的发展，蘑菇视频已经成为国内最受欢迎的视频平台之一，累计服务超过5000万用户。',
  
  mission: '我们的使命是让每个人都能轻松获取优质视频内容。我们相信，知识和娱乐不应该有门槛，好的内容应该被更多人看到。蘑菇视频始终坚持免费策略，通过技术创新不断优化用户体验，让高清视频观看变得更加简单、流畅。',
  
  vision: '成为全球最受欢迎的中文视频平台，连接创作者与观众，让优质内容触手可及。',
  
  values: [
    { title: '用户至上', description: '一切以用户体验为中心，持续优化产品和服务' },
    { title: '内容为王', description: '严格把控内容质量，为用户精选优质视频资源' },
    { title: '技术创新', description: '不断探索前沿技术，提升视频播放和推荐体验' },
    { title: '开放共享', description: '倡导知识的自由传播，打造开放包容的内容生态' },
  ],

  reputation: [
    {
      user: '张先生',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%2C%20warm%20natural%20lighting%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20corporate%20headshot%20style&width=80&height=80&seq=mogu-avatar-01&orientation=squarish',
      role: '科技爱好者',
      rating: 5,
      comment: '蘑菇视频真的太棒了！高清画质、流畅播放，内容更新也很快。平时最喜欢看科技类的内容，很多独家深度解析在其他平台都找不到。强烈推荐！',
      date: '2026年8月',
    },
    {
      user: '李女士',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20photo%2C%20warm%20natural%20lighting%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20corporate%20headshot%20style&width=80&height=80&seq=mogu-avatar-02&orientation=squarish',
      role: '全职妈妈',
      rating: 5,
      comment: '孩子特别喜欢蘑菇视频上的科学小实验和纪录片，内容质量很高，完全不用担心不适合孩子看。而且免费真的很良心，一家人都能用。',
      date: '2026年7月',
    },
    {
      user: '王同学',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20photo%2C%20warm%20natural%20lighting%2C%20intelligent%20expression%2C%20clean%20white%20background%2C%20casual%20headshot%20style&width=80&height=80&seq=mogu-avatar-03&orientation=squarish',
      role: '大学生',
      rating: 5,
      comment: '作为计算机专业的学生，蘑菇视频上的编程教程帮了我很多。讲解清晰易懂，比学校课程还实用。备考期间全靠蘑菇视频的课程资源。',
      date: '2026年8月',
    },
    {
      user: '赵先生',
      avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20male%20portrait%20photo%2C%20warm%20natural%20lighting%2C%20confident%20expression%2C%20clean%20white%20background%2C%20business%20headshot%20style&width=80&height=80&seq=mogu-avatar-04&orientation=squarish',
      role: '企业管理者',
      rating: 4,
      comment: '出差路上经常用蘑菇视频看纪录片和商业分析，手机端体验做得很好，省流量模式也很实用。内容质量整体不错，希望能有更多商业类的深度内容。',
      date: '2026年7月',
    },
  ],

  contact: {
    email: 'contact@moguvideo.cn',
    phone: '400-888-6666',
    address: '北京市海淀区中关村科技园区创新大厦18层',
    wechat: 'mogu_video_official',
    weibo: '@蘑菇视频在线观看',
    workingHours: '周一至周五 9:00 - 18:00',
  },

  milestones: [
    { year: '2018', event: '蘑菇视频正式上线，初期覆盖5个内容分类' },
    { year: '2019', event: '用户突破500万，新增4K超高清播放支持' },
    { year: '2020', event: '完成A轮融资，团队扩展至200人' },
    { year: '2021', event: '用户突破2000万，月活跃用户超过800万' },
    { year: '2022', event: '推出智能推荐系统，内容分类扩展至15个' },
    { year: '2023', event: '用户突破4000万，上线8K极清画质' },
    { year: '2024', event: '获评“最佳在线视频平台”，获行业多项大奖' },
    { year: '2025', event: '用户突破5000万，视频总量超过100万部' },
    { year: '2026', event: '全面升级AI推荐引擎，推出创作者扶持计划' },
  ],
};